import { useNetworkStore } from '../stores/networkStore';
import { showAlert } from './alert';

/**
 * Check if the device is online and the API is reachable before performing a mutation.
 * Shows an alert and returns false if not connected, otherwise returns true.
 *
 * Usage:
 *   if (!requireConnectivity()) return;
 *   await api.create(...);
 */
export function requireConnectivity(): boolean {
  const { connectivityState } = useNetworkStore.getState();
  if (connectivityState === 'online') return true;

  showAlert(
    connectivityState === 'offline' ? 'You are offline' : 'Server unavailable',
    'This action requires a connection. Please try again later.',
  );
  return false;
}
